import {
  ELogpayPaymentStatetypes,
  ILogpayPurchase,
  IPaymentRefundRequest,
  IPaymentTransactionRequest,
  ITicketForPurchase,
} from './payment-methods.interfaces';
import { z } from 'zod/v4';

const LOGPAY_CHECKOUT_RESPONSE_SCHEMA = z.object({
  redirectUrl: z.url(),
  transactionId: z.uuid().optional(),
});

const LOGPAY_PAYMENT_RESPONSE_SCHEMA = z.object({
  id: z.string().min(1),
  stateType: z.enum(ELogpayPaymentStatetypes),
});

export const PAYMENT_REFUND_REQUEST_SCHEMA: z.ZodType<IPaymentRefundRequest> =
  z.object({
    customerId: z.string().min(1),
    transactionId: z.string().min(1),
    amount: z.number().positive(),
  });

export const PAYMENT_TRANSACTION_REQUEST_SCHEMA: z.ZodType<IPaymentTransactionRequest> =
  z.object({
    transactionId: z.string().min(1),
  });

export const TICKET_FOR_PURCHASE_SCHEMA: z.ZodType<ITicketForPurchase> =
  z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    number: z.string().min(1),
    position: z.number().int().positive(),
    quantity: z.number().int().positive(),
    priceNet: z.number(),
    totalNet: z.number(),
    totalSum: z.number(),
    totalVat: z.number(),
    vat: z.number(),
  });

export const LOGPAY_PURCHASE_SCHEMA: z.ZodType<ILogpayPurchase> = z.object({
  referenceId: z.string().min(1),
  purpose: z.string().min(1),
  purchase: z.object({
    datetime: z.string().min(1),
    currency: z.literal('EUR'),
    totalNet: z.number(),
    totalVat: z.number(),
    totalSum: z.number(),
    articles: z.array(TICKET_FOR_PURCHASE_SCHEMA).min(1),
  }),
  paymentMethodId: z.string(),
  urlToInitiator: z.url(),
  urlToCancel: z.url(),
  urlToError: z.url(),
});

export const BUY_RESPONSE_SCHEMA = z.object({
  providerResponse: z.union([
    LOGPAY_CHECKOUT_RESPONSE_SCHEMA,
    LOGPAY_PAYMENT_RESPONSE_SCHEMA,
  ]),
  purchase: LOGPAY_PURCHASE_SCHEMA.optional(),
});
